<template>
  <tk-flex
    middle
    column
    center
    class="w-full h-full bg-white"
  >
    <tk-image :src="src"></tk-image>
  </tk-flex>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: require('@/assets/image/productDetail.png')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
